import { atom } from "recoil";

const claimDetailIdStore = atom<number | undefined>({
  key: "claimDetailId",
  default: undefined,
});

export default claimDetailIdStore;
